import BasePageStructure from 'src/components/BasePageStructure';
import styles from './TransferToOtherDistrict.module.css';
import { Box, Button, IconButton, Typography } from '@mui/material';
import SearchBar from 'src/components/SearchBar';
import AppStripedDataGrid from 'src/components/AppStripedDataGrid';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useState } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { EmployeeState, EmployeesService } from 'src/pehra-ts-client';
import { useQuery } from '@tanstack/react-query';

import ConditionalRenderQuery from 'src/components/ConditionalRenderQuery';
import EmployeeTable from '../Employees/components/EmployeeTable';
import TransferToOtherDistrictTable from './component/TransferToOtherDistrictTable';

export interface ITransferToOtherDistrict {}

const TransferToOtherDistrict: React.FC<ITransferToOtherDistrict> = () => {
  const [searchText, setSearchText] = useState<string>('');
  const [openNewEmployeeModal, setOpenNewEmployeeModal] = useState<boolean>(false);
  const [employeeFilter, setEmployeeFilter] = useState<any>({
    state: EmployeeState.TRANSFERRED_TO_ANOTHER_DISTRICT
  });

  const handleSearchChange = (text: string) => {
    setSearchText(text);
  };

  const fetchEmployeesQuery = useQuery({
    queryKey: ['employeeTransfferedToOtherDistrict'],
    queryFn: () => EmployeesService.getAllEmployees(employeeFilter)
  });

  const employeePositionComponent = (
    <Box className={styles.employeePositionContainer}>
      <Box className={styles.searchContainer}>
        <Box>{/* <SearchBar placeholder="Search Employees" searchText={searchText} handleSearchChange={handleSearchChange} /> */}</Box>
      </Box>
      <TransferToOtherDistrictTable rows={fetchEmployeesQuery.data?.employees} />
    </Box>
  );

  return (
    <BasePageStructure title="Transfer to Other District">
      <Box className={styles.container}>
        <ConditionalRenderQuery
          status={fetchEmployeesQuery.status}
          success={() => {
            return employeePositionComponent;
          }}
        />
      </Box>
      {/* <NewEmployeesModal openModal={openNewEmployeeModal} handleCloseModal={() => setOpenNewEmployeeModal(false)} /> */}
    </BasePageStructure>
  );
};

export default TransferToOtherDistrict;
